<template>
  <!--暗巷详情页-->
  <!-- 导航栏 -->
  <ZhaiHead></ZhaiHead>

  <div class="container-fluid zhu py-2">
    <!-- 详情顶部 -->
    <div class="row shengse py-2">
      <div class="px-4">
        <div><span class="Title">{{ details.name }}</span></div>
        <div class="ri mb-1">
          <small class="bi bi-clock ziti" id="upload-date">
            <span>&nbsp;{{ details.createTime ? details.createTime.substr(0, 10) : '' }}&nbsp;&nbsp;</span>
          </small>
          <small class="bi bi-person-fill ziti" id="collect"><span>&nbsp;匿名</span></small>
        </div>
        <div>
          <div class="py-1 jiushi">
            <span class="jiacu">所属地区：</span>&nbsp;{{ details.province }}-{{ details.city }}
          </div>
          <div class="mt-2">
            <button
                type="button"
                @click="toggleCollect"
                class="btn btn-outline-success bi-bag-heart"
            >
              {{ isCollected ? '已收藏' : '收藏' }}
            </button>
            <button
                type="button"
                @click="applyDel"
                class="btn btn-outline-success bi-trash3"
            >
              申请删除
            </button>
          </div>
        </div>
      </div>
    </div>
    <!-- 详情顶部 -->

    <!-- 详细介绍 -->
    <div class="row shengse mt-2">
      <div class="dixian px-4 py-2 d-flex justify-content-between">
        <div><i class="shou bi bi-info-circle"></i>详细介绍</div>
      </div>
    </div>
    <!-- 详细介绍 -->

    <!-- 截图部分：✅ 保持原有布局架构不变，只在内部加权限拦截 -->
    <div
        v-viewer="viewerOptions"
        class="row shengse pb-4 image-container"
        id="images"
        ref="gallery"
    >
      <!-- 未登录：不显示图片/正文，显示登录提示 -->
      <template v-if="!isLoggedIn">
        <div class="px-3 pt-3 pb-2 gate-box">
          请先
          <router-link to="/login" class="login-register-link">登录</router-link>
          或
          <router-link to="/register" class="login-register-link">注册</router-link>
        </div>
      </template>

      <!-- 已登录但非年度及以上的会员/已过期：不显示图片/正文，显示升级提示 -->
      <template v-else-if="!canViewBackAlley">
        <div class="py-2 jiushi gate-box">
          暗巷信息仅限VIP年度会员及以上会员可无限制查看，请
          <router-link to="/upgradeVIP" class="upgrade-vip-link">升级VIP</router-link>
        </div>
      </template>

      <!-- VIP有效：正常显示图片 + 文本（保持原结构） -->
      <template v-else>
        <div class="col-6 p-3" v-for="(img, index) in imgList" :key="index">
          <img class="Img w-100 clickable-img" :src="img" :alt="'图片' + (index + 1)" />
        </div>

        <div class="px-3 pb-3 mt-3">
          <p class="mb-2 indented" style="font-size:1rem;">
            {{ details.history }}
          </p>
        </div>
      </template>
    </div>
    <!-- 截图部分 -->

    <!-- 用户反馈 -->
    <div class="row shengse mt-2">
      <div class="dixian px-4 py-2 mb-3 d-flex justify-content-between">
        <div><i class="shou bi bi-chat-dots-fill"></i>用户反馈</div>
      </div>

      <ZhaiComment
          v-for="(feedback, index) in feedbackList"
          :key="index"
          :data="feedback"
      ></ZhaiComment>

      <div class="fk-ad">
        <button
            type="button"
            @click="checkLoginBeforeFeedback"
            class="btn btn-outline-success mx-auto bi-file-plus-fill"
        >
          我要反馈
        </button>
      </div>
    </div>
    <!-- 用户反馈 -->

    <!--本地其他推荐部分-->
    <div class="col-lg-4">
      <div class="bdcard">
        <div class="row rr mt-4">
          <div class="deziti zuo px-4 pb-2 d-flex justify-content-between">
            <div><i class="shou bi bi-geo-alt-fill"></i>本地其他推荐</div>
          </div>

          <div v-if="recommendList.length > 0">
            <div v-for="(item, index) in recommendList" :key="index" class="no-underline mb-1">
              <ZhaiBACard :data="item" @click="updateRoute(item.id)"></ZhaiBACard>
            </div>
          </div>

          <div v-else class="text-center text-muted py-4">
            暂无推荐内容
          </div>
        </div>
      </div>
    </div>
    <!--本地其他推荐部分-->
  </div>

  <!-- 公共底部 -->
  <ZhaiFoot></ZhaiFoot>
  <!-- 公共底部 -->

  <!-- 登录警示 模态框 -->
  <div class="modal fade" id="loginWarningModal" tabindex="-1" aria-hidden="true">
    <div class="modal-dialog modal-dialog-centered" style="max-width: 150px;">
      <div class="modal-content">
        <div class="modal-body text-center d-flex align-items-center justify-content-center">
          <i class="bi bi-emoji-frown" style="font-size: 1.5rem; color: #f16b6b;"></i>
          <p class="mb-0 ms-2" style="font-size: 0.9rem; color: #f16b6b;">请先登录！</p>
        </div>
      </div>
    </div>
  </div>

  <!-- 成功模态框 -->
  <div class="modal fade" id="successModal" tabindex="-1" aria-labelledby="successModalLabel" aria-hidden="true">
    <div class="modal-dialog modal-dialog-centered" style="max-width: 200px;">
      <div class="modal-content">
        <div class="modal-body d-flex align-items-center justify-content-center">
          <i class="bi bi-emoji-smile" style="font-size: 1.5rem; color: #00c26f;"></i>
          <p class="mb-0 ms-2" style="font-size: 0.9rem; color: #00c26f;"></p>
        </div>
      </div>
    </div>
  </div>

  <!-- 失败模态框 -->
  <div class="modal fade" id="errorModal" tabindex="-1" aria-labelledby="errorModalLabel" aria-hidden="true">
    <div class="modal-dialog modal-dialog-centered modal-shake" style="max-width: 200px;">
      <div class="modal-content shake">
        <div class="modal-body d-flex align-items-center justify-content-center">
          <i class="bi bi-emoji-frown" style="font-size: 1.5rem; color: #dc3545;"></i>
          <p class="mb-0 ms-2" style="font-size: 0.9rem; color: #dc3545;"></p>
        </div>
      </div>
    </div>
  </div>

  <!-- 我要反馈 模态框 -->
  <div class="modal fade" id="myModal">
    <div class="modal-dialog">
      <div class="modal-content">
        <div class="modal-header">
          <h4 class="modal-title motou">我要反馈</h4>
          <button type="button" class="btn-close" data-bs-dismiss="modal"></button>
        </div>

        <div class="ant-modal-body my-2">
          <form class="myform">
            <div class="form-group mt-3 px-2">
              <label style="font-size:1rem;">反馈信息：</label>
              <input
                  type="text"
                  id="feedback-info"
                  class="form-control motou"
                  v-model="feedbackInfo"
                  name="feedback-info"
                  placeholder=""
                  readonly
              >
            </div>

            <div class="form-group mt-4 px-2">
              <label style="font-size:1rem;">反馈内容：</label>
              <textarea
                  class="form-control"
                  id="content"
                  v-model="feedbackContent"
                  placeholder="平台鼓励反馈真实的体验，请勿提交违背事实的虚假反馈，一经发现将关闭你的评论权限，情节严重的将可能直接封号。"
              ></textarea>
            </div>

            <div class="form-group mt-4 px-2">
              <label style="font-size:1rem;">验证码：</label>
              <div style="max-width: 300px;">
                <CaptchaComponent ref="captchaComponent" @validate-captcha="validateCaptcha"></CaptchaComponent>
              </div>
            </div>

            <div class="form-group mt-3">
              <div class="text-center mb-3">
                <button
                    type="button"
                    @click="submitFeedback"
                    class="btn btn-success px-5 toushu feedback-submit-btn"
                >
                  提交
                </button>
              </div>
            </div>
          </form>
        </div>
      </div>
    </div>
  </div>

  <!-- 申请删除 模态框 -->
  <div class="modal" id="myModal2">
    <div class="modal-dialog">
      <div class="modal-content">
        <div class="modal-header">
          <h4 class="modal-title motou">申请删除 </h4>
          <button type="button" class="btn-close" data-bs-dismiss="modal"></button>
        </div>

        <div class="modal-body">
          <div class="ant-modal-body motou">
            <div>
              本站所有內容来自网友分享，如有内容侵犯到你的隐私、权益或未经你的允许而被他人发布，平台很愿意为你删除，我们同样憎恶出于报复他人的目的而发布的内容。
              请你提供相关证明材料（比如与帖子内容相符的生活照、或你在其他社交平台发布的链接等，或可以证明联系方式确属于你的证明材料）
              发邮件至yufenglou123@gmail.com，我们通常会在24小时内处理你的请求，最长不会超过48小时，如果事实逻辑清晰我们将及时为你删除。
            </div>
          </div>
        </div>

        <div class="modal-footer di text-center">
          <button type="button" class="btn btn-success d-block mx-auto toushu" data-bs-dismiss="modal">关闭</button>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import { Modal } from 'bootstrap';
import Viewer from 'viewerjs';
import 'viewerjs/dist/viewer.css';

import ZhaiHead from "../components/ZhaiHead";
import ZhaiFoot from "../components/ZhaiFoot";
import http from "../utils/http.js";
import { mapGetters, mapActions } from 'vuex';
import ZhaiComment from "../components/ZhaiComment";
import CaptchaComponent from "../componentspc/CaptchaComponent.vue";
import ZhaiBACard from "../components/ZhaiBACard";

export default {
  name: "MDetails2",
  components: {
    ZhaiHead,
    ZhaiFoot,
    ZhaiComment,
    CaptchaComponent,
    ZhaiBACard
  },

  data() {
    return {
      details: {
        id: "",
        name: "",
        uploadDate: "",
        collection: "",
        province: "",
        city: "",
        age: "",
        price: "",
        level: "",
        condition: "",
        account: "",
        remark: "",
        email: "",
        attention: "",
        phone: "",
        source: "",
        img: "",
        createTime: "",
        history: "",
        presets3: "",
        presets4: "",
        presets5: ""
      },
      imgList: [],
      feedbackList: [],
      feedbackInfo: "",
      feedbackContent: "",
      isCollected: false,
      viewerInstance: null,
      recommendList: [],

      // ✅ v-viewer 配置：未授权时禁用
      viewerOptions: {
        // v-viewer 会把 viewer 实例挂在 $viewer 上（不同版本略有差异）
        // 这里只是给它默认配置，真正的“禁用/销毁”我们在 initViewer 里做
        navbar: true,
        toolbar: true,
        tooltip: true,
        title: true,
        url: 'src'
      }
    };
  },

  computed: {
    ...mapGetters(['isLoggedIn', 'getUser']),

    // ✅ 和 PC 端一致的 VIP 过期判断
    vipExpired() {
      if (!this.isLoggedIn) return false;
      if (!this.getUser) return false;

      const raw =
          this.getUser.level_expire_date ??
          this.getUser.levelExpireDate ??
          this.getUser.level_expireDate ??
          null;

      if (raw === null || raw === undefined) return true;

      const trimmed = String(raw).trim();
      if (trimmed === "" || trimmed === "null" || trimmed === "undefined") return true;

      // 1) 时间戳（秒/毫秒）
      if (!Number.isNaN(Number(trimmed))) {
        const n = Number(trimmed);
        const ms = String(Math.trunc(n)).length === 10 ? n * 1000 : n;
        return ms < Date.now();
      }

      // 2) 字符串时间：空格->T，+0800->+08:00，仅日期补 23:59:59
      let s = trimmed;
      s = s.replace(' ', 'T');
      s = s.replace(/([+-]\d{2})(\d{2})$/, '$1:$2');
      if (/^\d{4}-\d{2}-\d{2}$/.test(s)) s += 'T23:59:59';

      const d = new Date(s);
      const ms = d.getTime();
      if (Number.isNaN(ms)) {
        console.warn('VIP expire date parse failed:', raw, 'normalized=', s);
        return true;
      }
      return ms < Date.now();
    },
    isAnnualVipOrAbove() {
      if (!this.isLoggedIn) return false;

      const level = String(this.getUser?.level || "").trim();
      if (!level || level === "null" || level === "undefined") return false;

      return (
          level.includes("年度会员") ||
          level.includes("永久会员")
      );
    },
    canViewBackAlley() {
      // 必须：登录 + 年度及以上 + 未过期
      return this.isLoggedIn && this.isAnnualVipOrAbove && !this.vipExpired;
    }

  },

  async created() {
    // ✅ 先把 user 补齐，避免首屏误判
    await this.checkLoginStatus();

    this.fetchDetails();
    this.fetchFeedbackList();
    this.checkCollectStatus();
    this.fetchRecommendList();
  },

  mounted() {
    this.initViewer();
  },

  watch: {
    imgList() {
      this.initViewer();
    },
    '$route.query.id'() {
      this.fetchDetails();
      this.fetchFeedbackList();
      this.fetchRecommendList();
    },

    // ✅ 登录/VIP 状态变化时，也同步处理 viewer
    isLoggedIn() {
      this.initViewer();
    },
    vipExpired() {
      this.initViewer();
    }
  },

  methods: {
    ...mapActions(['logout', 'checkLoginStatus']),

    updateRoute(id) {
      this.$router.push({ path: '/details2', query: { id } }).then(() => {
        window.scrollTo({ top: 0, behavior: 'smooth' });
      });
    },

    handleNavigateToAvoidFraud() {
      const modal5 = document.getElementById('myModal5');
      if (modal5) {
        const modalInstance = Modal.getInstance(modal5);
        if (modalInstance) modalInstance.hide();

        document.body.classList.remove('modal-open');
        const backdrops = document.getElementsByClassName('modal-backdrop');
        while (backdrops.length > 0) {
          backdrops[0].parentNode.removeChild(backdrops[0]);
        }
      }
      this.$nextTick(() => {
        this.$router.push('/avoidFraud');
      });
    },

    fetchDetails() {
      const id = this.$route.query.id;
      if (!id) return;

      http.get(`/platform/frontEnd/details2?id=${id}`)
          .then(response => {
            if (response.data.status === 1) {
              this.details = response.data.data;
              this.feedbackInfo = this.details.name;

              // ✅ 注意：即使未登录/非VIP，也允许把 imgList 算出来；模板里会拦截不展示
              this.imgList = [
                ...(this.details.img ? this.details.img.split(',').map(img => img.trim()) : []),
                ...(this.details.presets3 ? this.details.presets3.split(',').map(img => img.trim()) : []),
                ...(this.details.presets4 ? this.details.presets4.split(',').map(img => img.trim()) : []),
                ...(this.details.presets5 ? this.details.presets5.split(',').map(img => img.trim()) : [])
              ];

              this.checkCollectStatus();
            } else {
              console.error('获取详情数据失败:', response.data.msg);
            }
          })
          .catch(error => {
            console.error('获取详情数据时出错:', error);
          });
    },

    fetchRecommendList() {
      const id = this.details.id || this.$route.query.id;
      if (!id) return;

      http.get(`/platform/frontEnd/recommendList2?id=${id}`)
          .then(response => {
            if (response.data.status === 1) {
              this.recommendList = response.data.data || [];
            } else {
              console.error('获取推荐列表失败:', response.data.msg);
            }
          })
          .catch(error => {
            console.error('获取推荐列表时出错:', error);
          });
    },

    fetchFeedbackList() {
      const id = this.$route.query.id;
      if (!id) return;

      http.get(`/platform/frontEnd/feedbackList?bizType=2&bizId=${id}`)
          .then(response => {
            if (response.data.status === 1) {
              this.feedbackList = response.data.data || [];
            } else {
              console.error('获取用户反馈数据失败:', response.data.msg);
            }
          })
          .catch(error => {
            console.error('获取用户反馈数据时出错:', error);
          });
    },

    checkCollectStatus() {
      if (!this.isLoggedIn || !this.getUser?.id) return;

      const accountId = this.details.id;
      const userId = this.getUser.id;
      if (!userId || !accountId) return;

      const postData = { accountid: accountId, userid: userId, action: 'check' };

      http.post('/platform/frontEnd/handleCollect2', postData)
          .then(response => {
            if (response.data && response.data.status === 1) {
              this.isCollected = response.data.data.isCollected;
            } else {
              console.error('检查收藏状态失败:', response.data.msg);
            }
          })
          .catch(error => {
            console.error('检查收藏状态时出错:', error);
          });
    },

    toggleCollect() {
      if (!this.isLoggedIn) {
        this.showLoginWarningModal();
        return;
      }

      const accountId = this.details.id;
      const userId = this.getUser.id;
      const action = this.isCollected ? 'cancel' : 'collect';
      if (!userId || !accountId) return;

      const postData = { accountid: accountId, userid: userId, action };

      http.post('/platform/frontEnd/handleCollect2', postData)
          .then(response => {
            if (response.data && response.data.status === 1) {
              this.isCollected = !this.isCollected;
              this.showModal('successModal', this.isCollected ? '收藏成功' : '取消收藏成功', 'bi bi-emoji-smile', '#00c26f');
            } else {
              this.showModal('errorModal', action === 'collect' ? '收藏失败' : '取消收藏失败', 'bi bi-emoji-frown', '#dc3545');
            }
          })
          .catch(error => {
            console.error(`${action === 'collect' ? '收藏' : '取消收藏'}请求错误:`, error);
            this.showModal('errorModal', '请求发生错误，请稍后再试', 'bi bi-emoji-frown', '#dc3545');
          });
    },

    showLoginWarningModal() {
      const warningModalElement = document.getElementById('loginWarningModal');
      if (!warningModalElement) return;

      const warningModal = new Modal(warningModalElement);
      warningModal.show();

      warningModalElement.classList.add('shake-animation');
      setTimeout(() => {
        warningModal.hide();
        warningModalElement.classList.remove('shake-animation');
      }, 2000);
    },

    showModal(modalId, message, iconClass, textColor) {
      const modalElement = document.getElementById(modalId);
      if (!modalElement) return;

      const modalBodyP = modalElement.querySelector('.modal-body p');
      const icon = modalElement.querySelector('.bi');

      icon.className = iconClass;
      icon.style.color = textColor;
      modalBodyP.textContent = message;

      const modalInstance = new Modal(modalElement);
      modalElement.classList.add('shake-animation');
      modalInstance.show();

      setTimeout(() => {
        modalElement.classList.remove('shake-animation');
        modalInstance.hide();
      }, 3000);
    },

    applyDel() {
      const modalInstance = new Modal(document.getElementById('myModal2'));
      modalInstance.show();
    },

    showModalInfo(modalId) {
      const modalElement = document.getElementById(modalId);
      if (!modalElement) return;
      const modalInstance = new Modal(modalElement);
      modalInstance.show();
    },

    checkLoginBeforeFeedback() {
      const warningModalElement = document.getElementById('loginWarningModal');
      const warningModal = new Modal(warningModalElement);

      if (this.isLoggedIn) {
        const feedbackModal = new Modal(document.getElementById('myModal'));
        feedbackModal.show();
      } else {
        if (warningModalElement.classList.contains('show')) {
          warningModalElement.classList.remove('shake-animation');
          void warningModalElement.offsetWidth;
          warningModalElement.classList.add('shake-animation');
        } else {
          warningModalElement.classList.add('shake-animation');
          warningModal.show();
          setTimeout(() => warningModal.hide(), 2000);
          setTimeout(() => warningModalElement.classList.remove('shake-animation'), 600);
        }
      }
    },

    submitFeedback() {
      const codeInput = document.querySelector('.captcha-input');
      const enteredCaptcha = codeInput ? codeInput.value.trim() : '';
      const actualCaptcha = this.$refs.captchaComponent.captchaText;

      if (!this.feedbackContent || !this.feedbackContent.trim()) {
        this.showModal('errorModal', '必填项不可为空！', 'bi bi-emoji-frown', '#dc3545');
        return;
      }
      if (!enteredCaptcha) {
        this.showModal('errorModal', '必填项不可为空！', 'bi bi-emoji-frown', '#dc3545');
        return;
      }
      if (enteredCaptcha !== actualCaptcha) {
        this.showModal('errorModal', '验证码错误！', 'bi bi-emoji-frown', '#dc3545');
        this.$refs.captchaComponent.generateCaptcha();
        return;
      }

      const feedbackData = {
        message: this.feedbackContent,
        accountid: this.details.id,
        userid: this.getUser.id,
        username: this.getUser.username,
        userlevel: this.getUser.level
      };

      http.post('/platform/frontEnd/feedback', feedbackData, false, true)
          .then(response => {
            if (response.data.status === 1) {
              this.showModal('successModal', '反馈提交成功', 'bi bi-emoji-smile', '#00c26f');
              const feedbackModal = Modal.getInstance(document.getElementById('myModal'));
              if (feedbackModal) feedbackModal.hide();
            } else {
              this.showModal('errorModal', `反馈提交失败: ${response.data.msg}`, 'bi bi-emoji-frown', '#dc3545');
            }
          })
          .catch(error => {
            const errorMsg = error?.response?.data?.msg || '请求发生错误，请稍后再试';
            this.showModal('errorModal', `提交反馈时出错: ${errorMsg}`, 'bi bi-emoji-frown', '#dc3545');
          });
    },

    validateCaptcha(isValid) {
      if (!isValid) alert('图形验证码输入不正确！');
    },

    // ✅ 核心：权限拦截时销毁 Viewer，避免空初始化/可点击放大
    initViewer() {
      this.$nextTick(() => {

        // 不允许查看：销毁 viewer 并退出
        if (!this.canViewBackAlley) {
          if (this.viewerInstance) {
            this.viewerInstance.destroy();
            this.viewerInstance = null;
          }
          return;
        }
        // 允许查看：初始化 viewer
        const gallery = this.$refs.gallery;
        if (gallery) {
          if (this.viewerInstance) {
            this.viewerInstance.destroy();
          }

          this.viewerInstance = new Viewer(gallery, {
            url(image) {
              return image.src;
            }
          });
        }
      });
    }
  },

  beforeUnmount() {
    if (this.viewerInstance) this.viewerInstance.destroy();
  }
};
</script>

<style scoped>
/* 你原来的样式保持不动，仅补一个 gate-box（不影响布局结构） */
.gate-box {

  font-size: 1rem;
  line-height: 1.8;
}

/* ✅ 下面保持你原样式（我不改动，只原封不动保留你给的） */

/* 确保模态框显示在导航栏之上 */
#myModal4 {
  z-index: 1055 !important;
  overflow-y: auto;
}

#myModal4 .modal-content {
  height: 90vh;
  display: flex;
  flex-direction: column;
}

#myModal4 .modal-dialog {
  max-width: 90%;
  margin: 1rem auto;
}

#myModal4 .modal-body {
  overflow-y: auto;
  flex-grow: 1;
  padding: 1rem;
  font-size: 0.9rem;
  line-height: 1.5;
}

#myModal4 .modal-footer {
  position: sticky;
  bottom: 0;
  background-color: #fff;
  z-index: 10;
  padding: 0.5rem;
  text-align: center;
}

.fb {
  font-weight: bold;
  color: #00c26f;
}

.motou {
  font-size: 1rem !important;
}
.motout {
  font-size: 1rem !important;
}

.btn-outline-success {
  color: #00c26f;
  border-color: #00c26f;
  background-color: transparent;
  padding: 0.3rem 0.7rem !important;
  font-size: 0.9rem !important;
}

.btn-outline-success:hover {
  color: #00c26f;
  background-color: transparent;
  border-color: #00c26f;
  padding: 0.3rem 0.7rem !important;
  font-size: 0.85rem !important;
}

.btn-outline-success:active,
.btn-outline-success.active,
.btn-outline-success:focus,
.btn-outline-success:not(:disabled):not(.disabled):active,
.btn-outline-success:not(:disabled):not(.disabled).active,
.show > .btn-outline-success.dropdown-toggle {
  color: #00c26f;
  background-color: transparent;
  border-color: #00c26f;
  box-shadow: none;
  padding: 0.3rem 0.7rem !important;
  font-size: 0.9rem !important;
}

.toushu,
.feedback-submit-btn {
  background-color: #00c26f !important;
  border: none !important;
  padding: 0.3rem 0.7rem !important;
  font-size: 1rem !important;
}

.toushu:hover,
.toushu:active,
.toushu.active,
.toushu:focus,
.feedback-submit-btn:hover,
.feedback-submit-btn:active,
.feedback-submit-btn.active,
.feedback-submit-btn:focus {
  padding: 0.3rem 0.7rem !important;
  font-size: 0.85rem !important;
}

.shou {
  font-style: normal;
}

.bi-telephone-fill {
  font-size: 14px;
}

.text-primary {
  color: #2b2b37 !important;
}

.zhuzi {
  font-size: small;
}

.jiushi {
  font-size: 90%;
}

.indented {
  text-indent: 2em;
}

.fk-ad {
  text-align: center;
  padding-bottom: 2rem;
}

.bi-bag-heart {
  margin-right: 5px;
}

.bi-eye {
  margin-right: 5px;
}

.modal {
  margin-top: 4rem !important;
}

.ruhe {
  font-size: 0.8rem;
}

.zhu {
  margin-top: 80px;
}

.viewer-canvas img {
  display: block;
  max-width: 100%;
}

.login-register-link {
  color: #18b371 !important;
  font-size: inherit;
  text-decoration: none;
  padding: 0;
}

@keyframes shake {
  0%,
  100% {
    transform: translateX(0);
  }
  10%,
  30%,
  50%,
  70%,
  90% {
    transform: translateX(-5px);
  }
  20%,
  40%,
  60%,
  80% {
    transform: translateX(5px);
  }
}

.shake-animation {
  animation: shake 0.5s;
}

#loginWarningModal .modal-dialog,
#successModal .modal-dialog,
#errorModal .modal-dialog {
  display: flex;
  align-items: center;
  justify-content: center;
  height: 100%;
  margin: 0;
  position: absolute;
  top: 50%;
  left: 50%;
  transform: translate(-50%, -50%);
}

#loginWarningModal .modal-body,
#successModal .modal-body,
#errorModal .modal-body {
  padding: 0.25rem 0.5rem !important;
}

#loginWarningModal .modal-body p,
#successModal .modal-body p,
#errorModal .modal-body p {
  font-size: 0.9rem;
}

#loginWarningModal .modal-body i,
#successModal .modal-body i,
#errorModal .modal-body i {
  font-size: 1.5rem;
}

.form-control {
  font-size: 0.9rem;
}

#myModal {
  z-index: 1051;
}

#loginWarningModal,
#successModal,
#errorModal {
  z-index: 1052;
}

.upgrade-vip-link {
  color: #00c26f !important;
  font-size: inherit;
  text-decoration: none;
  cursor: pointer;
}
.upgrade-vip-link:hover {
  text-decoration: underline;
}
</style>
